import React from 'react';
import { SearchWrapper, Wrapper } from './filter-approval-orders.styles';
import { FilterApprovalOrdersProps } from './types';
import { Search } from '@shared/ui/search/search';
import { MenuFilters } from './menu-filter/menu-filter';
import { SORT_ORDER_CLEAR_PARAMETERS } from './constants';

export const FilterApprovalOrders: React.FC<FilterApprovalOrdersProps> = ({
    ordersParameters,
    setOrdersParameters,
}) => {
    return (
        <Wrapper>
            <SearchWrapper>
                <Search
                    sortParametersAfterClearSearch={SORT_ORDER_CLEAR_PARAMETERS}
                    parameters={ordersParameters}
                    setParameters={setOrdersParameters}
                />
            </SearchWrapper>
            <MenuFilters parameters={ordersParameters} setParameters={setOrdersParameters} />
        </Wrapper>
    );
};
